import $http from '../services/AxiosInstance';

interface Params {
  corredorId: string;
}

class CorredorRepository {
  static async getCorredor(params: Params = { corredorId: '0' }) {
    try {
      const response = await $http.get(`/corredores/${params.corredorId ? `${params.corredorId}` : ''}` );
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
}

export default CorredorRepository;
